import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getFleetHealthEvents } from '../../services/fleetHealthService';
import {
  fleetHealtEventsPageState,
  fleetHealthEventsState,
  loadingFleetHealthEventsState,
  searchFleetHealtEventState,
  updateFleetHealtEventsState,
} from '../../storage/fleetHealthEventsStates';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useLoading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { fleetHealthClientState, fleetHealthConfigurationState, fleetHealthEventTypeState, fleetHealthSubClientState } from '../../storage/fleetHealthStates';

export function FleetHealthEventsProvider() {
  const updateEvents = useRecoilValue(updateFleetHealtEventsState);
  const resetUpdateEvents = useResetRecoilState(updateFleetHealtEventsState);
  const setPaginatedEvents = useSetRecoilState(fleetHealthEventsState);
  const setLoadingEvents = useSetRecoilState(loadingFleetHealthEventsState);
  const [search, setSearch] = useRecoilState(searchFleetHealtEventState);
  const eventType = useRecoilValue(fleetHealthEventTypeState);
  const eventConfiguration = useRecoilValue(fleetHealthConfigurationState);
  const clientId = useRecoilValue(fleetHealthClientState);
  const subClientId = useRecoilValue(fleetHealthSubClientState);
  const [page, setPage] = useRecoilState(fleetHealtEventsPageState);
  const { loading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    setLoadingEvents(loading);
  }, [loading]);

  const load = async () => {
    if (loading) return;
    startLoading();
    const { paginatedResponse, error } = await getFleetHealthEvents(
      page, search ?? '', eventType, eventConfiguration, clientId, subClientId
    );
    if (!error && paginatedResponse) {
      if (page > 1) {
        setPaginatedEvents((prev) => ({
          hasNext: paginatedResponse.hasNext,
          total: paginatedResponse.total,
          items: [...prev!.items, ...paginatedResponse.items],
          totalEvents: paginatedResponse.totalEvents,
          totalProcessed: paginatedResponse.totalProcessed,
          totalToClose: paginatedResponse.totalToClose
        }));
      } else {
        setPaginatedEvents(paginatedResponse);
      }
    } else {
      setPaginatedEvents(undefined);
    }
    stopLoading();
  };

  useEffectOnce(() => {
    load();
    return () => {
      setSearch('');
      setPage(1);
    };
  });

  useUpdateEffect(() => {
    setPage(0);
  }, [search, eventType, eventConfiguration, clientId, subClientId]);

  useUpdateEffect(() => {
    if (page === 0) {
      setPage(1);
      return;
    }
    load();
  }, [page]);

  useUpdateEffect(() => {
    if (!updateEvents) return;
    load().finally(() => {
      resetUpdateEvents();
    });
  }, [updateEvents]);

  return null;
}
